export const nameRules = [
    v => !!v || 'Name is required',
    v => (v && v.length >= 3) || 'Name must be at least 3 characters',
    v => /^[a-zA-Z\s]+$/.test(v) || 'Name must only contain letters and spaces',
  ];
  
  export const emailRules = [
    v => !!v || 'Email is required',
    v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
  ];
  
  export const contactRules = [
    v => !!v || 'Phone number is required',
    // v => /^[0-9+\-()\s]{7,15}$/.test(v) || 'Phone number must be valid',
    v => /^\d+$/.test(v)||'This field only accept numbers'
  ];
  
  export const passwordRules = [
    v => !!v || 'Password is required',
    v => (v && v.length >= 8) || 'Password must be at least 8 characters',
    v => /[A-Z]/.test(v) || 'Password must contain at least one uppercase letter',
    v => /[a-z]/.test(v) || 'Password must contain at least one lowercase letter',
    v => /[0-9]/.test(v) || 'Password must contain at least one number',
    v => /[!@#$%^&*(),.?":{}|<>]/.test(v) || 'Password must contain at least one special character',
  ];
  
  export const schoolNameRules = [
    v => !!v || 'School name is required',
    // v => (v && v.length >= 3) || 'School name must be at least 3 characters',
  ];
  
  export const addressRules = [
    v => !!v || 'Address is required',
    // v => (v && v.length >= 10) || 'Address must be at least 10 characters',
  ];

    
  export const messageRules = [
    v => !!v || 'Message is required',
    v => (v && v.length >= 10) || 'Message must be at least 10 characters',
  ];